import Phaser from 'phaser';

import AnimationKeys from '../constants/AnimationKeys';
import TextureKeys from '../constants/TextureKeys';
import SceneKeys from '../constants/SceneKeys';

const MouseState = {
  Running: 'running',
  Killed: 'killed',
  Dead: 'dead',
};

class RocketMouse extends Phaser.GameObjects.Container {
  /** @type {Phaser.GameObjects.Sprite} */
  mouse;

  /** @type {Phaser.GameObjects.Sprite} */
  flames;

  /** @type {Phaser.Types.Input.Keyboard.CursorKeys} */
  cursors;

  /** @type {Phaser.Types.Input.ActivePointer} */
  pointer;

  mouseState = MouseState.Running;

  constructor(scene, x, y) {
    super(scene, x, y);

    // create flame sprite
    this.flames = scene.add
      .sprite(-63, -15, TextureKeys.RocketMouse)
      .play(AnimationKeys.RocketFlamesOn, true);
    this.enableJetpack(false);
    this.add(this.flames);

    // create mouse sprite
    this.mouse = scene.add
      .sprite(0, 0, TextureKeys.RocketMouse)
      .setOrigin(0.5, 1)
      .play(AnimationKeys.RocketMouseRun, true);
    this.add(this.mouse);

    // add a physics body
    scene.physics.add.existing(this);

    // offset the physics body by the negative height and negative half-width of RocketMouse
    this.body.setSize(this.mouse.width * 0.6, this.mouse.height * 0.7);
    this.body.setOffset(this.mouse.width * -0.3, -this.mouse.height + 15);

    this.cursors = scene.input.keyboard.createCursorKeys();
    this.pointer = scene.input.activePointer;
  }

  enableJetpack(state) {
    this.flames.setVisible(state);
  }

  kill() {
    if (this.mouseState !== MouseState.Running) {
      return;
    }

    this.mouseState = MouseState.Killed;
    this.mouse.play(AnimationKeys.RocketMouseDead);
    this.body.setAccelerationY(0);
    this.body.setVelocity(400, 0);
    this.enableJetpack(false);
  }

  preUpdate() {
    switch (this.mouseState) {
      case MouseState.Running: {
        if (this.cursors.space?.isDown || this.pointer.isDown) {
          this.body.setAccelerationY(-600);
          this.enableJetpack(true);
          this.mouse.play(AnimationKeys.RocketMouseFly, true);
        } else {
          this.body.setAccelerationY(0);
          this.enableJetpack(false);
        }
        if (this.body.blocked.down) {
          // touching the ground
          this.mouse.play(AnimationKeys.RocketMouseRun, true);
        } else if (this.body.velocity.y > 0) {
          this.mouse.play(AnimationKeys.RocketMouseFall, true);
        }
        break;
      }

      case MouseState.Killed: {
        this.body.velocity.x *= 0.99;
        if (this.body.velocity.x <= 100) {
          this.mouseState = MouseState.Dead;
        }
        break;
      }

      case MouseState.Dead: {
        this.body.setVelocity(0, 0);
        this.scene.scene.run(SceneKeys.GameOver);
        break;
      }

      default: {
        break;
      }
    }
  }
}

export default RocketMouse;
